import React from 'react';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import CreateWorkspaceModal from 'Shared/components/CreateWorkspaceModal/CreateWorkspaceModal';

type Props = {
  iconOnly?: boolean;
  onClick?: Function;
};

const CreateWorkspaceButton = ({ iconOnly = false, onClick }: Props) => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  const handleClick = () => {
    if (onClick) onClick();
    toggleIsOpen();
  };

  return (
    <>
      <WpButton variant="secondary" block onClick={handleClick}>
        {iconOnly ? <WpIcon name="plus" /> : 'Create Workspace'}
      </WpButton>
      {isOpen && <CreateWorkspaceModal isOpen={isOpen} toggleModal={toggleIsOpen} />}
    </>
  );
};

export default CreateWorkspaceButton;
